// extracted by mini-css-extract-plugin
export default {"lntModal":"styles_lnt-modal__D8vvz"};